/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUpgradeLicense
 */
export interface MelcoModelsUpgradeLicense {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    email_address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    referral_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUpgradeLicense
     */
    step?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsUpgradeLicense
     */
    assign_license?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpgradeLicense
     */
    language?: string | null;
}

export function MelcoModelsUpgradeLicenseFromJSON(json: any): MelcoModelsUpgradeLicense {
    return MelcoModelsUpgradeLicenseFromJSONTyped(json, false);
}

export function MelcoModelsUpgradeLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUpgradeLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'step': !exists(json, 'step') ? undefined : json['step'],
        'assign_license': !exists(json, 'assign_license') ? undefined : json['assign_license'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'language': !exists(json, 'language') ? undefined : json['language'],
    };
}

export function MelcoModelsUpgradeLicenseToJSON(value?: MelcoModelsUpgradeLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email_address': value.email_address,
        'serial_number': value.serial_number,
        'version_id': value.version_id,
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'step': value.step,
        'assign_license': value.assign_license,
        'melco_customer_id': value.melco_customer_id,
        'language': value.language,
    };
}


